"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _HBTable = require("./HBTable.styles");
var _useDetectScroll2 = require("../common/useDetectScroll");
var _reactScrollSync = require("react-scroll-sync");
var _colors = _interopRequireDefault(require("../../styles/colors"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function HBTableHorizontalShadowSyncScrollContainer(_ref) {
  var children = _ref.children,
    table = _ref.table;
  var ref = (0, _react.useRef)(null);
  var _useDetectScroll = (0, _useDetectScroll2.useDetectScroll)({
      elementRef: ref,
      direction: 'horizontal'
    }),
    isScrolled = _useDetectScroll.isScrolled,
    isScrolledToEnd = _useDetectScroll.isScrolledToEnd;
  var _table$options$meta = table.options.meta,
    isFirstColumnPinned = _table$options$meta.isFirstColumnPinned,
    isLastColumnPinned = _table$options$meta.isLastColumnPinned,
    isLastColumnFloating = _table$options$meta.isLastColumnFloating;
  return /*#__PURE__*/_react["default"].createElement(ShadowContainer, {
    $isScrolled: isScrolled,
    $isScrolledToEnd: isScrolledToEnd,
    $isFirstColumnPinned: isFirstColumnPinned,
    $isLastColumnPinned: isLastColumnPinned,
    $isLastColumnFloating: isLastColumnFloating
  }, /*#__PURE__*/_react["default"].createElement(_reactScrollSync.ScrollSyncPane, {
    innerRef: ref
  }, /*#__PURE__*/_react["default"].createElement(ScrollContainer, {
    ref: ref
  }, children)));
}
var _default = exports["default"] = HBTableHorizontalShadowSyncScrollContainer; // -------------------------- Styles -------------------------- //
var ScrollContainer = _styledComponents["default"].div.withConfig({
  displayName: "HBTableHorizontalShadowSyncScrollContainer__ScrollContainer",
  componentId: "sc-1522q8y-0"
})(["overflow:auto;scrollbar-width:none;::-webkit-scrollbar{display:none;}"]);
var commonShadowProps = {
  size: 12,
  offsetStart: -1
};
var ShadowContainer = _styledComponents["default"].div.withConfig({
  displayName: "HBTableHorizontalShadowSyncScrollContainer__ShadowContainer",
  componentId: "sc-1522q8y-1"
})(["position:relative;", " ", ""], function (_ref2) {
  var $isFirstColumnPinned = _ref2.$isFirstColumnPinned,
    $isScrolled = _ref2.$isScrolled;
  return $isFirstColumnPinned ? (0, _styledComponents.css)(["th:first-child,td:first-child{z-index:", ";position:sticky;left:0;", "}td:first-child{background-color:inherit;}"], _HBTable.TABLE_Z_INDEX.BOTTOM, (0, _HBTable.scrollShadow)(_objectSpread({
    isShadowActive: $isScrolled,
    direction: 'right'
  }, commonShadowProps))) : (0, _styledComponents.css)(["", ""], (0, _HBTable.scrollShadow)(_objectSpread({
    isShadowActive: $isScrolled,
    direction: 'left',
    isInset: true
  }, commonShadowProps)));
}, function (_ref3) {
  var $isLastColumnPinned = _ref3.$isLastColumnPinned,
    $isLastColumnFloating = _ref3.$isLastColumnFloating,
    $isScrolledToEnd = _ref3.$isScrolledToEnd;
  return $isLastColumnPinned ? (0, _styledComponents.css)(["th:last-child,td:last-child{position:sticky;right:0;}td:last-child{background-color:inherit;}", ""], $isLastColumnFloating ? (0, _styledComponents.css)(["th:last-child{", "}td:last-child{opacity:0;transition:opacity 60ms;}tr:is( :hover,:focus-visible,:focus-within,:has([data-state='open']) ) td:last-child{opacity:1;", "}", ""], applyShadowToFloatingElement(!$isScrolledToEnd, _colors["default"].neutral100), applyShadowToFloatingElement(!$isScrolledToEnd, "var(".concat(_HBTable.TABLE_ROW_BG_COLOR_VAR, ")") // Because it's not possible to use the 'inherit' keyword in a linear-gradient
  ), applyShadowToTableRightEdge) : (0, _styledComponents.css)(["th:last-child,td:last-child{", "}"], (0, _HBTable.scrollShadow)(_objectSpread({
    isShadowActive: !$isScrolledToEnd,
    direction: 'left'
  }, commonShadowProps)))) : applyShadowToTableRightEdge;
});
function applyShadowToFloatingElement(isShadowActive, color) {
  return (0, _HBTable.scrollShadow)({
    isShadowActive: isShadowActive,
    direction: 'left',
    size: 40,
    isFlat: true,
    flatColor: color
  });
}
function applyShadowToTableRightEdge(_ref4) {
  var $isScrolledToEnd = _ref4.$isScrolledToEnd;
  return (0, _HBTable.scrollShadow)(_objectSpread({
    isShadowActive: !$isScrolledToEnd,
    direction: 'right',
    isInset: true
  }, commonShadowProps));
}
//# sourceMappingURL=HBTableHorizontalShadowSyncScrollContainer.js.map